<script setup lang="ts">
import { ref, computed } from 'vue'
import { ChevronUpIcon, File04Icon } from 'front-library'

const optionShow = ref(false)
const showLabel = ref<any>(null)

const props = withDefaults(
  defineProps<{
    modelValue: string | number
    label?: string
    options: any[]
    showKey?: string
    valueKey?: string
    placeholder?: string
  }>(),
  {
    modelValue: '',
    label: '',
    options: () => [],
    showKey: 'name',
    valueKey: 'id',
    placeholder: ''
  }
)

const emit = defineEmits(['update:modelValue'])

const emitUpdate = (val: any) => {
  emit('update:modelValue', val)
}

const nameValue = computed(() => {
  return (
    props.options.find(item => item[props.valueKey] === props.modelValue)?.[
      props.showKey
    ] || `${props.placeholder}`
  )
})

const showOptions = () => {
  optionShow.value = true
}

const selectOption = (option: any) => {
  optionShow.value = false

  emitUpdate(String(option[props.valueKey]))
}

const closeOptions = () => {
  optionShow.value = false
}
</script>
<template>
  <div class="relative block">
    <div tabindex="0" @focusout="closeOptions" ref="showLabel">
      <label
        class="w-full flex text-blue-600 font-bold bg-blue-100 px-3 rounded-2xl shadow-sm border py-1 cursor-pointer"
        @click="showOptions">
        <File04Icon class="w-4 mr-1" /> {{ `${nameValue}` }}
        <span v-if="options.length > 0" class="truncate ..."> </span>
        <ChevronUpIcon
          class="w-4"
          :class="[
            optionShow ? 'rotate-180 duration-700' : 'rotate-0 duration-700'
          ]" />
      </label>
      <ul
        class="absolute z-10 mt-1 bg-white border border-gray-300 rounded-md shadow-xl max-h-72 overflow-y-auto scroll px-1"
        v-show="optionShow && options.length > 0">
        <li
          class="dropdown-item rounded-md my-1 hover:bg-blue-500 hover:text-white cursor-pointer text-sm px-2 py-1"
          @mousedown="selectOption(option)"
          v-for="(option, index) in options"
          :key="index">
          {{ typeof option == 'object' ? option[showKey] : option }}
        </li>
      </ul>
    </div>
  </div>
</template>
